/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Import_MenuInputs */

const en_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import...`)
};

const fr_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer...`)
};

const de_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import...`)
};

const it_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importare...`)
};

const ru_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт...`)
};

const es_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar...`)
};

const zh_cn2_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口...`)
};

const ja_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入...`)
};

const hi_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात करना...`)
};

const pt_pt2_markers_import_menu = /** @type {(inputs: Markers_Import_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar...`)
};

/**
* | output |
* | --- |
* | "Import..." |
*
* @param {Markers_Import_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_import_menu = /** @type {((inputs?: Markers_Import_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Import_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_import_menu(inputs)
	if (locale === "de") return de_markers_import_menu(inputs)
	if (locale === "it") return it_markers_import_menu(inputs)
	if (locale === "ru") return ru_markers_import_menu(inputs)
	if (locale === "es") return es_markers_import_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_import_menu(inputs)
	if (locale === "ja") return ja_markers_import_menu(inputs)
	if (locale === "hi") return hi_markers_import_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_import_menu(inputs)
	return en_markers_import_menu(inputs)
});